<template>
  <div :key="key">
    <div class="s-request-card" :class="[
      {
        'request-accepted': requestIsAccepted,
      },
      {
        'request-waiting': isTradeWaiting,
      },
      {
        'request-declined': requestIsDeclined,
      },
      {
        'trade-completed': isTradeCompleted,
      },
    ]">
      <!-- Item Image -->
      <div class="item-thumb-wrapper" :class="[
          { '': isTradeWaiting },
          {
            '':
              requestIsAccepted || requestIsDeclined || isTradeCompleted,
          },
        ]">
          <div class="item-type-wrapper" :class="[getTradeColor, 'first-line-want'] ">
            <p class="item-type-text">
              {{ getPosterName(activity) }} is
              <span class="request-trade-type">
                {{ getTradeType(activity).replace(/give|lend|receive|borrow/gi, formatTradeType) }}
              </span>
            </p>
          </div>
          <div class="item-thumb-image" :class="[getTradeBorder]">
            <img :src="getItemImagePath(activity)" alt="product" class="item-img"
              @click="goToItemDetails(activity)" />
          </div>
      </div>
      <!-- Item Content -->
      <div class="item-content-wrapper">
        <div class="item-content-header">
          <div data-toggle="tooltip" data-placement="top" :data-original-title="getItemTitle(activity)" :data-html="true">
            <p class="item-content-header-nameItem" @click="goToItemDetails(activity)" :data-cy="`linkItemDetails-${getItemTitle(activity)}`">
              {{ getItemTitle(activity) }}
            </p>
          </div>

          <p class="item-content-header-posted">
            Posted on <time class="item-content-header-posted-date" datetime="2017-03-24T18:18">{{ getTimeAgo(activity.createdAt) }}</time> by {{ getPosterUsername }}
          </p>
        </div>
        <div class="item-content-body">
          <div class="item-content-body-wrapper">
            <div class="item-body-payment-type">
              <div class="item-payment-type">
                <span class="item-price-mypost" v-if="getItemPrice.class === 'free'">
                  FREE
                </span>
                <span class="item-price-mypost" v-if="getItemPrice.class === 'cash'">
                  {{ getItemPrice.value }}
                </span>
                <span class="item-price-mypost" v-if="getItemPrice.class === 'points'">
                  {{ getItemPrice.value }}
                  <img class="mb-3" src="/img/Polygon_7.svg" alt="Swampum" width="12px" height="12px" />
                </span>
              </div>
            </div>
            <div class="item-body-info-boxes">
              <div class="request-accepted-box" v-if="isTradeCompleted">
                <md-card-content class="trade-state-ontime" :class="[{ 'set-in-columns': isTradeCompleted }]">
                  <span class="ontime-text trade-completed-text" :class="[getTradeStateClass]" :data-cy="`requestStatus-${getItemTitle(activity)}`">
                    {{ getTradeStateText }}
                  </span>
                  <span class="ontime-timestamp">{{ getTimeStamp }}</span>
                </md-card-content>
              </div>
              <div class="request-accepted-box" v-if="!isTradeCompleted && Object.keys(acceptedRequest).length === 0">
                <div class="request-accepted-box-icon">
                  <img v-if="getTradeStateText.includes('DECLINED')" src="/svg-icons/item-reject-icon.svg" alt="Item Reject Request Icon" width="20px" height="20px">
                  <img v-if="getTradeStateText.includes('ACCEPTED')" src="/svg-icons/item-accept-icon.svg" alt="Item Reject Request Icon" width="20px" height="20px">
                  <img v-if="getTradeStateText.includes('WAITING')" src="/svg-icons/item-waiting-icon.svg" alt="Item Reject Request Icon" width="20px" height="20px">
                </div>

                <div class="request-accepted-box-text">
                  <p class="accept-text accept-text--desktop">{{ getTradeStateText }}</p>
                  <p class="accept-text accept-text--mobile">{{ getTradeStateTextOnMobile }}</p>
                  <span class="request-accepted-ontime-timestamp" v-if="activity.type === this.iType.RECEIVE || activity.type === this.iType.BORROW">You offered on {{ getTimeStamp }}</span>
                  <span class="request-accepted-ontime-timestamp" v-else>You requested on {{ getTimeStamp }}</span>
                </div>
              </div>
              <div v-if="Object.keys(acceptedRequest).length > 0 && !isTradeCompleted">
                <ItemReceivedSentStatus @updateItemStatus="updateItemStatus" :item="activity" :acceptedRequest="acceptedRequest" />
              </div>
            </div>
          </div>
        </div>
        <div class="item-content-actions">
          <div class="item-details-action active messages" @click="openChat()">
            <div class="item-details-action--icon">
              <img src="/svg-icons/rounded-message-icon.svg" alt="message icon" width="20px" height="20px">
            </div>
            <span class="item-details-action-text">Messages</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemType from "@/enum/item-type";
import itemStatus from "@/enum/item-status";
import requestSituation from "@/enum/request-situation";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import ItemReceivedSentStatus from "@/components/molecules/ItemReceivedSentStatus";
export default {
  name: "ActivityRequestPost",
  props: ["item"],
  mixins: [ItemHelperVue, UserHelperVue],
  components: {
    ItemReceivedSentStatus
  },
  data() {
    return {
      iStatus: itemStatus,
      iType: itemType,
      reqSituation: requestSituation,
      key: 0,
    };
  },
  methods: {
    formatTradeType(tradeType) {
      switch (tradeType) {
        case 'give':
          return 'GIVING';
        case 'lend':
          return 'LENDING';
        case 'borrow':
          return 'BORROWING';
        case 'receive':
          return 'RECEIVING';
        default:
          return ''
      }
    },
    updateItemStatus() {
      this.$emit("updateItemStatus");
      this.key += 1;
    },
    openChat() {
      if (this.isUserAuthenticated) {
        this.$emit("openWindowPopup");
      } else {
        this.$router.push(`/s-app/item-details/${this.item.id}`);
      }
    },
    goToItemDetails(activity) {
      this.$router.push(`/s-app/item-details/${activity.id}`);
    },
    getTimeAgo(time) {
      const date = new Date(time);
      return date.toLocaleString('en-us', { dateStyle: 'short' });
    },
    getTradeType(activity) {
      if (activity.type === this.iType.GIVE) {
        return "give";
      } else if (activity.type === this.iType.RECEIVE) {
        return "receive";
      } else if (activity.type === this.iType.LEND) {
        return "lend";
      } else if (activity.type === this.iType.BORROW) {
        return "borrow";
      }
    },
    usernameIsSmall(poster) {
      if (poster.firstName.length > 6) {
        return poster.username.length < 7;
      }
      return poster.username.length < 13;
    },
    getPosterNameOrUser(activity) {
      if (this.usernameIsSmall(activity.poster)) {
        return this.getPosterName(activity);
      }
      return "The user";
    },
    setUpdated(dueDate) {
      let updated = new Date();
      if (this.item.changeSituationAt) {
        updated = new Date(this.item.changeSituationAt);
        updated.setDate(updated.getDate() + dueDate);
      }
      return updated;
    }
  },
  computed: {
    activity() {
      return {
        ...this.item.item,
        user: this.item.item.poster,
      };
    },
    getTradeBorder() {
      let type = this.activity.type;
      return type === itemType.GIVE || type === itemType.LEND
        ? "border-image-tertiary"
        : "border-image-offer";
    },
    getTradeColor() {
      switch (this.activity.type) {
        case 1:
        case 3:
          return "tertiary";
        case 2:
        case 4:
          return "offer";
        default:
          return "";
      }
    },
    getPosterUsername() {
      if (this.activity.user.username) return "@" + this.activity.user.username;
      return "";
    },
    getTradeStateText() {
      if (this.activity.status === this.iStatus.RECEIVED) {
        return "TRADE COMPLETED";
      }
      if (this.item.situation === this.reqSituation.OPEN) {
        return "WAITING FOR RESPONSE";
      } else if (this.item.situation === this.reqSituation.ACCEPTED) {
        return this.getPosterName(this.activity) + " ACCEPTED";
      } else if (this.item.situation === this.reqSituation.REJECTED) {
        return this.getPosterName(this.activity) + " DECLINED";
      }

      return "";
    },
    getTradeStateTextOnMobile() {
      if (this.activity.status === this.iStatus.RECEIVED) {
        return "TRADE COMPLETED";
      }
      if (this.item.situation === this.reqSituation.OPEN) {
        return "WAITING";
      } else if (this.item.situation === this.reqSituation.ACCEPTED) {
        return this.getPosterName(this.activity) + " ACCEPTED";
      } else if (this.item.situation === this.reqSituation.REJECTED) {
        return this.getPosterName(this.activity) + " DECLINED";
      }

      return "";
    },
    getTradeStateClass() {
      if (this.item.situation === this.reqSituation.ACCEPTED) {
        return "trade-state-accepted";
      } else if (this.item.situation === this.reqSituation.REJECTED) {
        return "trade-state-declined";
      }

      return "trade-state-normal";
    },
    getTradeTypeClass() {
      if (this.activity.type === this.iType.GIVE) {
        return "trade-type-give";
      } else if (this.activity.type === this.iType.RECEIVE) {
        return "trade-type-receive";
      } else if (this.activity.type === this.iType.LEND) {
        return "trade-type-lend";
      } else if (this.activity.type === this.iType.BORROW) {
        return "trade-type-borrow";
      }

      return "";
    },
    getTimeStamp() {
      if (this.item.situation === this.reqSituation.OPEN) {
        return this.getTimeAgo(this.item.createdAt);
      } else {
        return this.getTimeAgo(this.item.changeSituationAt);
      }
    },
    requestIsAccepted() {
      return this.item.situation === this.reqSituation.ACCEPTED;
    },
    requestIsDeclined() {
      return this.item.situation === this.reqSituation.REJECTED;
    },
    isAcceptedDecliendOrWaiting() {
      return (
        this.item.situation === this.reqSituation.ACCEPTED ||
        this.item.situation === this.reqSituation.REJECTED ||
        this.item.situation === this.reqSituation.OPEN
      );
    },
    isTradeWaiting() {
      return this.item.situation === this.reqSituation.OPEN;
    },
    isTradeCompleted() {
      return this.activity.status === this.iStatus.RECEIVED;
    },
    setDueDate() {
      let dueDate;
      if (
          this.activity.type === itemType.RECEIVE ||
          this.activity.type === itemType.BORROW
        ) {
          dueDate = this.activity.posterId === this.loggedUser.id ? 20 : 10;
        } else {
          dueDate = this.activity.posterId === this.loggedUser.id ? 10 : 20;
        }
        return dueDate;
    },
    acceptedRequest() {
      let d = new Date();
      let dueDate = 0;
      let updated = new Date();
      if (this.activity.requests?.length) {
        let result = {};
        result = this.activity.requests.find((request) => {
          dueDate = this.setDueDate;

          if (request.changeSituationAt) {
            updated = new Date(request.changeSituationAt);
            updated.setDate(updated.getDate() + dueDate);
          }
          return (
            request.situation === requestSituation.ACCEPTED &&
            (d > updated ||
              this.activity.status === itemStatus.NOT_SENT ||
              this.activity.status === itemStatus.NOT_RECEIVED)
          );
        });
        result = result ? result : {};
        return result;
      } else if (
        this.item.situation === requestSituation.ACCEPTED &&
        (this.activity.status === itemStatus.IDLE ||
          this.activity.posterId !== this.loggedUser.id)
      ) {
        dueDate = this.setDueDate;

        updated = this.setUpdated(dueDate)
        let result = {};
        if (
          d > updated ||
          this.activity.status === itemStatus.NOT_SENT ||
          this.activity.status === itemStatus.NOT_RECEIVED
        ) {
          result = this.item;
        }
        return result;
      } else {
        return {};
      }
    },
    getItemPrice() {
      if (this.activity.cash === 0 && this.activity.points === 0) {
        return { value: "FREE", class: "free", symbol: "" };
      } else if (this.item.payWith === "points") {
        return {
          value: this.activity.points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          class: "points",
          symbol: "P"
        };
      } else if (this.item.payWith === "money") {
        return {
          value: this.activity.cash.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          }),
          class: "cash",
          symbol: "$",
        };
      }

      return { value: "", class: "", symbol: "" };
    },
  },
};
</script>

<style lang="scss" scoped>
/* style for card */
.s-request-card {
  width: 100%;
  height: 100%;
  background-color: #FFF;
  box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.2);
  border-radius: 4px;
  padding: 1rem;

  display: flex;
  flex-direction: column;
  gap: 10px;
}

.item-thumb-wrapper {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.item-type-wrapper {
  width: 100%;
  height: 100%;
  min-height: 30px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.item-type-text {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: white;
  margin: 0;
}

.item-thumb-image {
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: 5px;
}

.item-img {
  width: 100%;
  height: 100%;
  max-height: 180px;
  background-size: cover;
}

.item-content-wrapper {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px
}

.item-content-header {
  width: 100%;
  height: 30%;

  display: flex;
  flex-direction: column;
}

.item-content-header-nameItem {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  margin: 0;
}

.item-content-header-posted {
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.6);
  margin: 0;

  visibility: hidden;
}

.item-content-header-posted-date {
  color: rgba(0,0,0,0.75);
  font-weight: bold;
}

.item-content-body{
  width: 100%;
  height: 100%;
}

.item-content-body-wrapper {
  width: 100%;
  height: 100%;

  display: flex;
}

.item-body-payment-type {
    width: 100%;
}

.item-payment-type {
    width: 100%;
}

.item-body-info-boxes {
  width: 100%;
  height: 100%;

  display: flex;
  align-self: center;
  justify-content: center;
}

.item-price-mypost {
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: rgba(0,0,0,0.7);
  margin: 0;
}

.request-accepted-box {
  width: 100%;
  height: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.request-accepted-box-icon {
  width: 30%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.request-accepted-box-text {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.request-accepted-box-text .accept-text--mobile {
  width: 100%;

  display: flex;
}

.request-accepted-box-text .accept-text--desktop {
  display: none;
  visibility: hidden;
}

.request-accepted-ontime-timestamp {
  font-weight: 700;
  letter-spacing: 1.25px;
  color: $black;
  opacity: 0.6;
}

.accept-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 1.25px;
  color: rgba(0,0,0,0.7);
  margin: 0;
}

.item-content-actions {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px
}

.item-mini-info-content {
  display: flex;
  align-items: center;
  justify-content: left;
}

.request-waiting {
  border: 3px solid transparent;
}

.first-line-want {
  text-align: center;
}

.tertiary.first-line-want {
  color: white !important;
  background-color: $tertiary;
}

.offer.first-line-want {
  color: white !important;
  background-color: $offer;
}

.layout-top-content {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.want-trade-completed {
  border: 1px solid #c4c4c4;
}

.main-img {
  background: transparent !important;
  width: 100%;
  height: 100%;
}

.request-thumbs-wrap {
  padding: 0.3rem;
  padding-bottom: 0.5rem;
}

.request-thumb-content {
  height: 180px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.request-item-price {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 16px;
  width: fit-content;
  position: absolute;
  top: 145px;
  right: 5px;

  span {
    color: #fff;
    font-weight: 700;
    font-size: 14px;
  }
}

.item-price-content {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0.1rem 0.5rem 0.1rem 0.5rem;

  img {
    width: 16px !important;
    height: 16px !important;
  }
}

.image-price-content {
  align-self: center;
  margin-left: 1rem;
}

.border-image-unavailable {
  margin-top: 0 !important;
  border: 1px solid $dark;
  box-sizing: border-box;
}

.border-image-tertiary {
  margin-top: 0 !important;
  border: 3px solid $tertiary;
  box-sizing: border-box;
  color: $tertiary;
}

.border-image-offer {
  margin-top: 0 !important;
  border: 3px solid $offer;
  box-sizing: border-box;
  color: $offer;
}

.md-card-header:last-child {
  margin-bottom: 10px !important;
}
</style>

<style lang="scss" scoped>
.item-details-action {
  width: 50%;
  min-height: 32px;
  border-radius: 4px;
  color: white;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px
}

.item-details-action.active {
  cursor: pointer;
  background-color: $primary;
}

.item-details-action-text{
  width: 100%;
  display: flex;
  justify-content: center;
}

.buttons-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 15px;
}

.item-details-action.messages {
  margin-left: auto;
}

.item-details-action--icon {
  width: 30%;
  padding: 0.3rem;

  display: flex;
  justify-content: center;
}

/* style for header */
.md-header-content,
.user-name-content {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}
.md-header-content {
  padding: unset;
  padding-left: 10px;
}

.card-poster-name {
  font-size: 16px;
  font-weight: bold;

  a {
    color: $black !important;
  }

  a:hover {
    color: $primary !important;
  }
}

.posted-info {
  color: $black !important;
  opacity: 1;
}
.trade-info-content {
  width: 75%;
}
.overflow-text {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.s-tooltip {
  margin-top: -6px;
  background: rgba(147, 147, 147, 0.4);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  border-radius: 4px;
  color: $black;
  font-weight: 500;
}
.posted-date {
  font-weight: bold;
}
</style>

<style lang="scss" scoped>
/* style for trade state / shipping state */
.trade-waiting-ontime {
  margin-top: 1.84rem !important;
}

.trade-waiting-span-content {
  margin-right: 4rem;
}

.trade-state-ontime {
  display: flex;
  align-items: flex-end;

  .ontime-timestamp {
    font-weight: 700;
    letter-spacing: 1.25px;
    color: $black;
    opacity: 0.5;
  }

  .ontime-text {
    text-transform: uppercase;
    font-size: 18px;
    letter-spacing: 1.5px;
  }

  .trade-completed-text {
    color: $primary;
    opacity: 0.5;
  }
}

.set-in-columns {
  flex-direction: column;
}

.trade-state-accepted,
.trade-state-declined,
.trade-state-normal {
  font-weight: 700;
  font-size: 18px;
  line-height: 16px;
  letter-spacing: 1.25px;
}

.trade-state-accepted {
  color: $primary;
}

.trade-state-declined {
  color: $danger;
}

.trade-state-normal {
  color: $black;
}

.tertiary {
  color: $tertiary;
}

.offer {
  color: $offer;
}
</style>

<style lang="scss" scoped>
/* style for trade type content */
.want-content {
  display: flex;
  flex-direction: column;
  background: #f4f4f4;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  max-width: 195px;
  max-height: fit-content;
  margin-left: 3rem;
  padding: 0.5rem !important;
}

.first-line-want {
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.25px;
}

.request-trade-wants {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.4);
}

.request-item-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 150px; // some width
  text-align: center;
}

.request-trade-type {
  font-weight: 700;
  text-transform: uppercase;
}

.trade-type-lend,
.trade-type-give {
  color: $tertiary;
}

.trade-type-receive,
.trade-type-borrow {
  color: $offer;
}

.span-content {
  display: flex;
  flex-direction: column;
}

.send-message-action {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
  margin-right: -2rem;
  .md-button.md-dense {
    height: fit-content;
  }
}
.send-message-action .send-message-button i {
  width: 38px;
  height: 38px;
  font-size: 38px !important;
}
</style>

<style lang="scss" scoped>
@media screen and (min-width: 600px){
  .request-accepted-box-text .accept-text--mobile {
    display: none;
    visibility: hidden;
  }
  .request-accepted-box-text .accept-text--desktop {
    width: 100%;

    display: flex;
    visibility: visible;
  }

}
@media only screen and (min-width: 769px) and (max-width: 1023px) {
  .s-request-card {
    flex-direction: row;
    align-items: center;
  }

  .item-thumb-wrapper {
    width: 60%;
  }

  .item-content-body {
    min-height: 70px;
  }

  .item-type-wrapper {
    height: 0;
  }
}

@media only screen and (min-width: 1024px) {
  .s-request-card {
    flex-direction: row;
    align-items: center;
  }

  .item-thumb-wrapper {
    width: 60%;
  }

  .item-content-body {
    min-height: 100px;
  }
}

@media only screen and (min-width: 1025px) {

.item-content-wrapper {
  gap: 25px
}

.item-thumb-wrapper {
  width: 40%;
}

.item-content-body {
  min-height: 60px;
}

.request-accepted-box-icon {
  width: 10%;
}

.request-accepted-box-text {
  align-items: start;
}

.item-content-actions {
  margin-top: 1.5rem
}

}
</style>
